import { t } from "i18next";
import { orderBy } from "lodash";
import { useLocation } from "react-router";
import { OBJECT_TYPE } from "common/constants";
import { useGetWorkflowsForCustomMapGeometryQuery } from "../../generated/graphql";
import { WorkflowListItem } from "../AddressPanel/Workflows";
import { FlexRow } from "../Common/__styles__/Layout";
import { EmptyState } from "../Common/EmptyState";
import { Body } from "../Common/Typography";
import { CreateWorkflowButton } from "../Workflows/CreateWorkflowButton";
import { ContentWrapper } from "./__styles__/ObjectInformationPanel";
import { ObjectInfoPanelTabProps } from "./types";

const Workflows = ({ customMap, geometry }: ObjectInfoPanelTabProps) => {
  const { pathname, search } = useLocation();
  const prevLocation = `${pathname}${search}`;

  const { data, loading, refetch } = useGetWorkflowsForCustomMapGeometryQuery({
    variables: { geometryId: geometry.id },
  });

  let content;

  if (loading) {
    content = <em>{t("common-loading")}</em>;
  } else if (data?.customMapGeometry?.workflows.length === 0) {
    content = (
      <EmptyState
        icon="add-file"
        title="No workflows created"
        body="Add a new workflow to start tracking activity."
      />
    );
  } else {
    const sortedWorkflows =
      orderBy(data?.customMapGeometry?.workflows, "updatedAt", "desc") ?? [];

    content = sortedWorkflows.map(workflow => (
      <WorkflowListItem
        workflow={workflow}
        key={workflow.id}
        prevLocation={prevLocation}
      />
    ));
  }

  return (
    <ContentWrapper>
      <div>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <Body size="large" type="emphasis">
            Workflows
          </Body>
          <CreateWorkflowButton
            objectId={geometry.id}
            customMapId={customMap.id}
            objectType={OBJECT_TYPE.CUSTOM_MAP_GEOMETRY}
            objectDisplay={geometry.label}
            onSuccess={refetch}
          />
        </FlexRow>
        {content}
      </div>
    </ContentWrapper>
  );
};

export default Workflows;
